<template>
    <el-dialog :visible.sync="modifyBankCardDialog" width="25%" top="8vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false  @close="closeDialog" :show-close = false v-loading="loading"  element-loading-text="请求处理中" 
               element-loading-spinner="el-icon-loading" element-loading-background="rgba(0.8, 0, 0, 0.3)">
         <el-card>
            <el-form ref="dateForm" label-width="100px" label-position="right" v-model="request">
                <el-form-item label="真实姓名" required><el-input type="text" v-model="request.realName" style="width: 200px"></el-input></el-form-item>
                <el-form-item label="预留手机号" required><el-input type="text" v-model="request.phone" style="width: 200px"></el-input></el-form-item>
                <el-form-item label="银行卡号" required><el-input type="text" v-model="request.bankCard" style="width: 200px"></el-input></el-form-item>
                <el-form-item label="身份证号" required><el-input type="text" v-model="request.idCard" style="width: 200px"></el-input></el-form-item>
            </el-form>
         </el-card>
        <span slot="footer" class="dialog-footer">
            <el-button style="background-color:#A9F5F2;margin: 0" @click="modifyBankCardDialog = false">取消</el-button>
            <el-button style="background-color:#A9F5A9" @click="modifyBankCard()">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {modifyBankCard} from '../../../api/withdraw/withdrawapply.js'
export default {
    data() {
        return {
            modifyBankCardDialog: false,
            request: {
                id: '',
                bankCard: '',
                phone: '',
                realName: '',
                idCard: ''
            },
            loading: false
        }
    },
    methods: {
         init(item){
            this.request.id = item.userId;
            this.request.bankCard = item.creditCard;
            this.request.phone = item.mobile;
            this.request.realName = item.realName;
            this.request.idCard = item.cardNo;
            this.modifyBankCardDialog = true;
        },

        /**
         * 修改银行卡
         */
        modifyBankCard(){
            modifyBankCard(this.request).then(result=>{
                if(result.code === "000000"){
                    this.$emit("modify-succeed");
                    this.$message({
                        message: '修改成功!',
                        type: 'success',
                        duration: 3000
                    });
                    this.closeDialog();
                }
            })
            
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.request.id = "";
            this.request.bankCard = "";
            this.request.phone = "";
            this.request.realName = "";
            this.request.idCard = "";
            this.modifyBankCardDialog = false;
        }
    }
}
</script>
<style scpoed>

</style>


// WEBPACK FOOTER //
// src/pages/finance/withdrawmanagement/modifyBankCard.vue